import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import moment = require('moment');

export function maxAgeValidator(maxYears: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const inputDate = moment(control.value);
    const cutoffYear = moment().year() - maxYears;

    return inputDate.year() < cutoffYear
      ? { maxAgeExceeded: { value: control.value } }
      : null;
  };
}
